import React from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export const UnsavedChangesDialog: React.FC<{
  open: boolean;
  isReadOnly: boolean;
  isSaving: boolean;
  onCancel: () => void;
  onDiscard: () => void;
  onSave: () => void;
}> = ({ open, isReadOnly, isSaving, onCancel, onDiscard, onSave }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!isSaving) onCancel();
      }}
      aria-labelledby="agent-advanced-settings-unsaved-title"
      aria-describedby="agent-advanced-settings-unsaved-description">
      <DialogTitle id="agent-advanced-settings-unsaved-title">{t('dialog.title2')}</DialogTitle>
      <DialogContent>
        <DialogContentText id="agent-advanced-settings-unsaved-description">
          {t('dialog.content2')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isSaving}>
          {t('action.cancel')}
        </Button>
        <Button onClick={onDiscard} disabled={isSaving}>
          {t('common.discard')}
        </Button>
        {!isReadOnly && (
          <Button onClick={onSave} variant="contained" disabled={isSaving}>
            {isSaving ? <CircularProgress size={20} color="inherit" /> : t('action.save')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
